export default __webpack_public_path__ + "static/media/ic-available-tech.343bddbd.svg";